import { render } from "./settingstabset.vue?vue&type=template&id=6138555e"
import script from "./settingstabset.vue?vue&type=script&lang=js"
export * from "./settingstabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__